
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/threads/connect",
      function () {
        return require("private-next-pages/threads/connect/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/threads/connect"])
      });
    }
  